<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div class="sidebar-content todo-sidebar">
        <div class="todo-app-menu">
          <div class="add-task">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              data-v-step="1"
              class="tw-rounded-lg"
              variant="primary"
              @click="newTask"
            >
              {{ $t('Add Task') }}
            </b-button>
          </div>
          <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="sidebar-menu-list scroll-area">
            <!-- Filters -->
            <b-list-group class="list-group-filters">
              <b-list-group-item
                v-for="filter in taskFilters"
                :key="filter.title + $route.path"
                :active="isDynamicRouteActive(filter.route)"
                :to="filter.route"
                class="d-flex align-items-center"
                @click="hide"
              >
                <font-ai :icon="filter.icon" class="mr-75 font-small-4" />
                <span class="align-text-bottom line-height-1">{{ filter.title }}</span>
              </b-list-group-item>
            </b-list-group>

            <!-- Tags -->
            <div class="mt-2 mb-50 px-2 d-flex justify-content-between">
              <h6 class="section-label mb-0">Task type</h6>
              <!--                            <feather-icon icon="PlusIcon"/>-->
            </div>

            <b-list-group class="list-group-labels">
              <b-list-group-item
                v-for="type in taskType"
                :key="type.title + $route.path"
                :active="isDynamicRouteActive(type.route)"
                :to="type.route"
                @click="hide"
              >
                <span :class="`bullet-${type.color}`" class="bullet bullet-sm mr-1" />
                <span>{{ type.title }}</span>
              </b-list-group-item>
            </b-list-group>

            <!-- Tags -->
            <div class="mt-2 mb-50 px-2 d-flex justify-content-between">
              <h6 class="section-label mb-0">Tags</h6>
              <!--                            <feather-icon icon="PlusIcon"/>-->
            </div>

            <b-list-group class="list-group-labels">
              <b-list-group-item
                v-for="tag in taskTags"
                :key="tag.title + $route.path"
                :active="isDynamicRouteActive(tag.route)"
                :to="tag.route"
                @click="hide"
              >
                <span :class="`bullet-${tag.color}`" class="bullet bullet-sm mr-1" />
                <span>{{ tag.title }}</span>
              </b-list-group-item>
            </b-list-group>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
    <div class="bg-sidebar" @click="hide"></div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {BButton, BListGroup, BListGroupItem} from 'bootstrap-vue'
import {isDynamicRouteActive} from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BListGroup,
    BListGroupItem,
    VuePerfectScrollbar,
  },
  props: {
    taskTags: {
      type: Array,
      required: true,
    },
    taskType: {
      type: Array,
      required: true,
    },
    isTaskSidebarActive: {
      type: Boolean,
    },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    }

    return {
      perfectScrollbarSettings,
      isDynamicRouteActive,
    }
  },
  computed: {
    taskFilters() {
      return [
        {
          title: this.$t('All'),
          icon: 'fa-solid fa-list-ul',
          route: {name: 'tasks', params: {filter: 'all'}},
        },
        {
          title: this.$t('My Tasks'),
          icon: 'fa-solid fa-list-check',
          route: {name: 'tasks-filter', params: {filter: 'my-tasks'}},
        },
        {
          title: this.$t('Inbox'),
          icon: 'fa-solid fa-inbox',
          route: {name: 'tasks-filter', params: {filter: 'inbox'}},
        },
        {
          title: this.$t('Important'),
          icon: 'fa-regular fa-star',
          route: {name: 'tasks-filter', params: {filter: 'important'}},
        },
        {
          title: this.$t('Completed'),
          icon: 'fa-solid fa-check-double',
          route: {name: 'tasks-filter', params: {filter: 'completed'}},
        },
        {
          title: this.$t('Deleted'),
          icon: 'fa-regular fa-trash-can',
          route: {name: 'tasks-filter', params: {filter: 'deleted'}},
        },
      ]
    },
  },
  methods: {
    newTask() {
      this.$emit('create-task')
    },
    hide() {
      this.$emit('close-left-sidebar')
    },
  },
}
</script>

<style lang="scss">
@import '~@/assets/scss/variables/variables';

.sidebar {
  z-index: 3;

  .bg-sidebar {
    display: none;
  }
}

.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item {
  border-left: 3px solid #0000 !important;
  line-height: 1;
}

.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item.active,
.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item:focus,
.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item:hover {
  color: $primary;
}

.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item.active,
.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item:focus,
.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item:hover {
  background: #f5f8fa !important;
  border-radius: 0 5px 5px 0 !important;
}

.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item.active {
  border-color: $primary !important;
}

.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item {
  padding: 0.58rem 1.5rem;
  border: 0;
  border-radius: 0 !important;
}

.sidebar .todo-sidebar .todo-app-menu .list-group .list-group-item {
  font-weight: 500;
  letter-spacing: 0.4px;
}

.sidebar .todo-sidebar .todo-app-menu .list-group-filters .list-group-item {
  border-radius: 0 !important;
}

.sidebar .todo-sidebar .todo-app-menu .list-group {
  padding-right: 10px !important;
  gap: 2px;
}

.list-group-item + .list-group-item.active {
  margin-top: 0;
}

.sidebar-menu-list {
  position: relative;
  height: calc(100% - 80px);
}

.sidebar-left.show {
  .bg-sidebar {
    display: block;
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>
